<script setup>
import { ref } from 'vue'

import { FORM, SPECKLE, useDrawerStore } from '@/stores/drawer'
const drawerStore = useDrawerStore()

const rail = ref(true)
</script>

<template>
  <v-navigation-drawer class="py-0" width="60" v-model="rail" :elevation="0">
    <v-list class="py-0">
      <v-list-item
        prepend-icon="mdi-file-edit"
        @click="drawerStore.toggleCalculationDrawer(FORM)"
      ></v-list-item>
<!--      <v-list-item @click.stop="drawerStore.toggleCalculationDrawer(SPECKLE)">-->
<!--        <v-icon size="x-large" icon="custom:speckleLogoIcon"></v-icon>-->
<!--      </v-list-item>-->
    </v-list>
  </v-navigation-drawer>
</template>
